/*
 * File: PageHeader.tsx
 * Project: rosita
 * -----
 * Last Modified: 18 Feb 2022 4:37:54 pm
 * -----
 * Copyright (c) 2022 Elegant Software Solutions All rights reserved.
 */

import { Col, Divider, Row, Space, Typography } from 'antd';
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';
import { ReactComponent as MdsiLogo } from 'assets/mdsi-logo.svg';
import { InlineStylesModel } from 'models/InlineStylesModel';
import { Link } from 'react-router-dom';
import { useGetApplicationByIdQuery } from 'redux/services/freddyCadabby/freddyCadabbyApi';
import { useAppSelector } from 'redux/store';
import { UserDropdown } from './UserDropdown';

export const PageHeader = (): JSX.Element => {
  const { user } = useAppSelector((state) => state.app);
  const { xs } = useBreakpoint();
  const { data } = useGetApplicationByIdQuery(process.env.REACT_APP_APPLICATION_ID);

  const styles: InlineStylesModel = {
    container: {
      alignItems: 'center',
      maxWidth: 1920,
      flex: 1
    },
    appName: {
      display: 'flex',
      cursor: 'pointer',
      color: '#84859a',
      alignItems: 'flex-end',
      flex: 1
    },
    mainContainer: {
      color: 'white'
    },
    link: {
      color: '#84859a'
    },
    userMenu: {
      fontSize: '15px'
    }
  };

  return (
    <div style={{ height: 110, color: '#84859a', backgroundColor: '#1f1e2e' }}>
      <Row style={{ maxWidth: 1920, width: '100%', padding: xs ? '0px 20px' : '0px 50px', margin: '0 auto', height: '100%' }} align={'middle'} justify={'space-between'}>
        <Col>
          <Row align={'middle'}>
            <Space size={10}>
              <a href={process.env.REACT_APP_ERNIE_REDIRECT_URL} style={styles.link}>
                <MdsiLogo height={xs ? 20 : 30} width={xs ? 60 : 85} />
              </a>

              {!xs && (
                <a href={process.env.REACT_APP_ERNIE_REDIRECT_URL}>
                  <Typography.Paragraph style={{ fontWeight: 'normal', color: 'gray', margin: 0, fontSize: xs ? 18 : 24 }}>Acuity</Typography.Paragraph>
                </a>
              )}
            </Space>

            {!xs && <Divider type="vertical" style={{ backgroundColor: 'gray', width: 2, height: 20 }} />}
            <Link to="/" style={styles.link}>
              <Typography.Paragraph style={{ fontWeight: 'normal', color: 'gray', margin: 0, fontSize: xs ? 18 : 24, marginLeft: xs ? 8 : 0 }}>Product Catalog</Typography.Paragraph>
            </Link>
          </Row>
        </Col>
        <Col>
          <Row align="middle" style={styles.userMenu}>
            {!xs && user?.name?.toUpperCase()}
            <UserDropdown />
          </Row>
        </Col>
      </Row>
    </div>
  );
};
